window.addEventListener("load", function () {
  const unitField = document.querySelector("#custom-quantity-selector-by-measure .unit-field");
  const boxesQtty = document.querySelector("#custom-quantity-selector-by-measure .boxes-qtty");
  const unitQtty = document.querySelector("#custom-quantity-selector-by-measure .unit-qtty");
  const minusQttyCta = document.querySelector("#custom-quantity-selector-by-measure .minus-cta");
  const plusQttyCta = document.querySelector("#custom-quantity-selector-by-measure .plus-cta");
  const productUnitQttyValue = unitField.getAttribute("data-unit-quantity-value");
  const defaultQuantityField = document.querySelector('quantity-input .quantity__input');

  const customQuantitySelectorByMeasure = {
    init: () => {
      customQuantitySelectorByMeasure.customQuantityListeners();

      customQuantitySelectorByMeasure.unitQttyCalc(defaultQuantityField.value);
      // Observa o valor do input de quantidade padrão e chama a função customQuantitySelectorByMeasure.unitQttyCalc() assim que detecta alterações.
      customQuantitySelectorByMeasure.observeDefaultQttyInputValueChange((newValue) => {
        if (newValue == 1) {
          customQuantitySelectorByMeasure.unitQttyCalc(newValue)
        }
      });
    },
    unitQttyCalc(newQtty) {
      if(newQtty < 1) newQtty = 1;

      boxesQtty.innerText = newQtty

      unitQtty.innerText = newQtty * productUnitQttyValue;
      unitField.value = productUnitQttyValue;

      if (newQtty === 1) {
        minusQttyCta.setAttribute("disabled", true)
      }

      if (newQtty > 1) {
        minusQttyCta.removeAttribute("disabled")
      }
    },
    customQuantityListeners: () => {
      function unitCalc (el) {
        const unitValue = parseFloat(el.value);

        const newBoxesQtty = Math.ceil(unitValue / productUnitQttyValue);

        boxesQtty.innerText = newBoxesQtty;
        unitQtty.innerText = newBoxesQtty * productUnitQttyValue;

        defaultQuantityField.value = newBoxesQtty;
      }

      unitField.addEventListener("change", function () {
        unitCalc(this)
      })

      unitField.addEventListener("blur", function () {
        unitCalc(this)
      })

      //unitField Mask
      unitField.addEventListener("input", function (e) {
        let value = e.target.value.replace(/\D/g, '');
        e.target.value = (parseInt(value, 10) / 100).toFixed(2);
      });

      minusQttyCta.addEventListener("click", function () {
        const newQtty = parseInt(boxesQtty.innerText) - 1;
        customQuantitySelectorByMeasure.unitQttyCalc(newQtty)
        defaultQuantityField.value = newQtty;
      })

      plusQttyCta.addEventListener("click", function () {
        const newQtty = parseInt(boxesQtty.innerText) + 1;
        customQuantitySelectorByMeasure.unitQttyCalc(newQtty)
        defaultQuantityField.value = newQtty;
      })

      defaultQuantityField.addEventListener("change", function () {
        customQuantitySelectorByMeasure.unitQttyCalc(this.value)
      })
    },
    observeDefaultQttyInputValueChange: (callback) => {
      if (!defaultQuantityField) {
        console.error(`Input com o seletor "${inputSelector}" não encontrado.`);
        return;
      }

      let lastValue = defaultQuantityField.value;

      const checkValueChange = () => {
        const currentValue = defaultQuantityField.value;
        if (currentValue !== lastValue) {
          lastValue = currentValue;
          callback(currentValue);
        }
      };

      const observer = new MutationObserver(() => checkValueChange());
      observer.observe(defaultQuantityField, { attributes: true, attributeFilter: ['value'] });

      const intervalId = setInterval(() => checkValueChange(), 100);

      const parentObserver = new MutationObserver(() => {
        if (!document.body.contains(defaultQuantityField)) {
          observer.disconnect();
          clearInterval(intervalId);
          parentObserver.disconnect();
        }
      });

      parentObserver.observe(defaultQuantityField.parentNode || document.body, {
        childList: true,
        subtree: true,
      });

      // Limpa no unload da página
      window.addEventListener('beforeunload', () => {
        observer.disconnect();
        clearInterval(intervalId);
        parentObserver.disconnect();
      });
    }
  }

  customQuantitySelectorByMeasure.init();
})